"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _Header = require("./Header.style");
var _Text = _interopRequireDefault(require("../../../../Text"));
const Header = _ref => {
  let {
    title,
    onBack
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Header.NavHeader, {
    "data-test-id": "res-menu-header"
  }, /*#__PURE__*/_react.default.createElement(_Header.BackButton, {
    onClick: onBack,
    "data-test-id": "res-menu-header-back"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "chevron-left",
    size: "lg",
    color: _uiKit.theme.colours.PRIMARY_1,
    style: {
      cursor: 'pointer'
    }
  })), /*#__PURE__*/_react.default.createElement(_Header.LabelWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "Body",
    variant: "BoldWhite",
    intlText: title
  })));
};
var _default = exports.default = Header;